module.exports = __webpack_public_path__ + "static/philadelphia-7e529d7b353355662623e57d956593e5.png";